module.exports = __webpack_public_path__ + "img/1.7fbd4e72.png";